import workspaceQuery from 'graphql/queries/nominal/NominalProductAccountSetWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalProductAccountSetListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalProductAccountSetQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalProductAccountSetDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalProductAccountSetMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalProductAccountSetFragment.graphql';

const NominalProductAccountSet = {
  type: 'NominalProductAccountSet',
  title: 'Product Account Sets',
  formTitle: 'Nominal Product Account Set',
  formUrl: '/Nominal/ProductAccountSet/Details/',
  workspaceUrl: '/Nominal/ProductAccountSet/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'code',
  },
  fragment,
  screenReference: 'NOMINAL_PRODUCT_ACCOUNT_SET',
};

export default NominalProductAccountSet;
